import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';
import {
  BadgeComponent,
  ConnectedOverlayDirective,
  OverlayOriginDirective,
} from '@recruitee/user-interface';

import { FeatureTooltipModule } from '../../ui/feature-tooltip/feature-tooltip.module';
import { FeatureTooltipBadgeComponent } from './feature-tooltip-badge.component';

@NgModule({
  imports: [
    BadgeComponent,
    CommonModule,
    ConnectedOverlayDirective,
    FeatureTooltipModule,
    I18nModule,
    OverlayOriginDirective,
  ],
  declarations: [FeatureTooltipBadgeComponent],
  exports: [FeatureTooltipBadgeComponent],
})
export class FeatureTooltipBadgeModule {}

export { FeatureTooltipBadgeComponent };
